import { createAction } from "redux-actions";

import { moduleSlug } from "../constants";

export const clearCredentials = createAction(`${moduleSlug}/CLEAR_CREDENTIALS`);

export const getCredentials = createAction(`${moduleSlug}/GET_CREDENTIALS`);
export const getCredentialsSuccess = createAction(`${moduleSlug}/GET_CREDENTIALS/SUCCESS`);
export const getCredentialsError = createAction(`${moduleSlug}/GET_CREDENTIALS/ERROR`);

export const setSelectedCredentials = createAction(`${moduleSlug}/SET_SELECTED_CREDENTIALS`);

export const changeEnabledCredentials = createAction(`${moduleSlug}/CHANGE_ENABLED_CREDENTIALS`);

export const deleteCredentials = createAction(`${moduleSlug}/DELETE_CREDENTIALS`);

export const setCredentialsManagerDialog = createAction(`${moduleSlug}/SET_CREDENTIAL_MANAGER_DIALOG`);
export const mergeCredentialsManagerDialog = createAction(`${moduleSlug}/MERGE_CREDENTIAL_MANAGER_DIALOG`);
export const createCredentials = createAction(`${moduleSlug}/CREATE_CREDENTIALS`);
export const editCredentials = createAction(`${moduleSlug}/EDIT_CREDENTIALS`);
